<template>
  <!-- 用v-show控制显示，动画通过类名触发 -->
  <div
      class="loading-mask"
      :class="{ 'animate-fade': visible, 'leaving': isLeaving }"
      :style="{ visibility: visible ? 'visible' : 'hidden' }"
  >
    <div class="loading-content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,// 控制显示的开关
      isLeaving: false
    }
  }
}
</script>

<!-- 去掉scoped，确保样式全局生效 -->
<style>
/* 基础遮罩样式（默认隐藏，v-show控制display） */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0; /* 初始透明 */
  visibility: hidden;
  pointer-events: none;
  transition: visibility 0s linear 3s;
}

/* 显示时触发关键帧动画 */
.loading-mask.animate-fade {
  /* 应用淡入动画：1秒内从透明到不透明 */
  animation: fadeIn 3s ease forwards;
  pointer-events: auto;
  visibility: visible; /* 显示时强制可见 */
  transition-delay: 0s; /* 立即显示 */
}

/* 定义淡入关键帧 */
@keyframes fadeIn {
  0% {
    opacity: 1; /* 开始透明 */
  }
  100% {
    opacity: 0; /* 结束不透明 */
  }
}

/* 隐藏时触发淡出动画（通过移除visible实现） */
.loading-mask.animate-fade.leaving {
  animation: fadeOut 3s ease forwards;
  pointer-events: none;
}

/* 定义淡出关键帧 */
@keyframes fadeOut {
  0% {
    opacity: 0; /* 开始不透明 */
  }
  100% {
    opacity: 0; /* 结束透明 */
  }
}

.loading-content {
  /* 调整加载提示框样式，增强对比 */
  color: #ffffff; /* 白色文字更醒目 */
  font-size: 20px; /* 稍大一点的字体 */
  padding: 15px 30px; /* 增加内边距 */
  border-radius: 8px; /* 圆角更明显 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* 增加阴影，突出层次 */
}
</style>